import { useContext } from 'react';
import AppContext from '../context/AppContext';
import routeConfiguration from '../routes/routeConfiguration';

export const useRouteConfiguration = () => {
  const { treetId } = useContext(AppContext);
  return routeConfiguration(treetId);
};
